<template>
  <div class="shopsettle content_center">
    <!-- <el-scrollbar ref="myScrollbar"
                  :style="{height:height}"
                  wrap-class="content-scrollbar"
                  :native="false"
                  :noresize="false"
                  tag="div"> -->
    <div class="shopsettle_receivingInformation">
      <div class="ft28 D1D1D1 mtb20">收货信息</div>
      <ReceivingInf
        @getStartShipQuantity="getStartShipQuantity"
        ref="info"
        :receivingInfo="receivingInfo"
      />
    </div>
    <div class="shopsettle_orderinfo" ref="orderRef">
      <div class="ft28 D1D1D1 mtb20 shopsettle_orderinfo_title">订单信息</div>
      <!-- 从购物车，收藏夹添加货补，本品商品 -->
      <div class="addsprouct">
        <AddprouctShop @addshopcarspruct="addshopcarspruct" />
      </div>
      <!-- 订单信息 -->
      <OrderInfo
        ref="orderInfo"
        :id="id"
        :productModal="productModal"
        :tableDataList="tableData"
        :tableScrollTop="tableScrollTop"
        :discountAmount="orderInfo.discountAmount.toString()"
        @change="changeCal"
        @quantityOrder="quantityOrder"
      />
    </div>
    <!-- 备注信息 -->
    <div class="mt40">
      <p class="C787878 mb10 ft16">备注信息</p>
      <el-input
        type="textarea"
        :rows="4"
        placeholder="若供货方式选择工厂直发拼单，则备注必填，请填写拼单的订单号、拼单客户名称等信息"
        v-model="remarks"
      ></el-input>
    </div>
    <!-- 订单结算信息 -->
    <div class="mt40">
      <p class="C787878 mb10 ft16">订单结算信息</p>
      <div class="padding20 ft14 userInfo">
        <div class="flex flex-info">
          <p>
            <span class="C787878">订单总金额(元):</span>
            <span class="C000">￥{{ orderInfo.amount || '0' }}</span>
          </p>
          <p>
            <span class="C787878">政策优惠金额(元):</span>
            <span class="C000">￥{{ orderInfo.promotionAmount || '0' }}</span>
          </p>
          <p>
            <span class="C787878">使用货补费用(元):</span>
            <span class="C000">￥{{ orderInfo.repAmount || '0' }}</span>
          </p>
          <p>
            <span class="C787878">返利及现金垫付抵扣金额(元):</span>
            <span class="C000">
              <!-- <el-input-number
                size="small"
                style="width: 100px"
                v-model="orderInfo.discountAmount"
                controls-position="right"
                :min="0"
                :max="orderInfo.maxDiscountAmount"
              ></el-input-number> -->
              <el-input
                size="small"
                style="width: 100px"
                v-model="orderInfo.discountAmount"
              ></el-input>
            </span>
            <span class="C787878" style="font-size:12px">
              （最大可抵扣金额(元)：
              <span class="C000">{{ orderInfo.maxDiscountAmount }}</span>
              )
            </span>
          </p>
          <!-- <p><span class="C787878">折扣可用余额（元）：</span><span class="C000">￥{{orderInfo.usableAmount || '0'}}</span></p> -->
        </div>
        <!-- <div class="flex mt10 flex-info">
           
        </div> -->
        <div class="flex mt10 flex-info">
          <p>
            <span class="C787878">本单应付金额(元):</span>
            <span class="C000 max-font color-red"
              >￥{{ orderInfo.actualAmount || '0' }}</span
            >
          </p>
          <p>
            <span class="C787878">起运量(KG):</span>
            <span class="C000 max-font">{{ startShipQuantity || '0' }}</span>
          </p>
          <p>
            <span class="C787878">本单总重量(KG):</span>
            <span class="C000 max-font">{{
              orderInfo.weightOfKilogram || '0'
            }}</span>
          </p>
        </div>
      </div>
    </div>
    <!-- 提交订单，暂存，取消 按钮-->
    <div class="warning-row">
      {{ calSucessMsg }}
    </div>
    <div class="submit textright">
      <el-button
        class="mr40"
        type="primary"
        :loading="submitLoading"
        @click="submitOrderList('N')"
      >
        提交订单
      </el-button>
      <el-button
        class="mr40"
        type="primary"
        plain
        :loading="submitLoading"
        @click="submitOrderList('Y')"
      >
        暂存
      </el-button>
      <el-button @click="submitOrderList('Z')">取消</el-button>
    </div>
    <!-- 提交订单，暂存，取消 组件-->
    <div v-if="orderBoolean">
      <SubmitholdOrder
        :orderBoolean="orderBoolean"
        :receivingInfo="receivingInfo"
        :titles="titles"
        :id="id"
        :orderCode="orderCode"
        :discountAmount="orderInfo.discountAmount.toString()"
        @SubmitholdOrders="SubmitholdOrders"
      ></SubmitholdOrder>
    </div>
    <div v-if="visible">
      <!-- 添加收藏，购物车，暂存，补货组件 -->
      <AddorderProucttable
        :visible.sync="visible"
        :modelType="modelType"
        @resetPopupData="resetPopupData"
        @submitPopupData="submitPopupData"
        @handleClose="handleClose"
      />
    </div>
    <!-- </el-scrollbar> -->
  </div>
</template>
<script>
import SubmitholdOrder from './Components/SubmitholdOrder' //暂存，结算，删除订单
import ReceivingInf from './Components/ReceivingInf' //收货信息
// import ReplenOrderInfo from './Components/ReplenOrderInfo'; //促销政策
import OrderInfo from './Components/OrderInfo' //订单信息
import AddprouctShop from './Components/AddprouctShop' //添加商品按钮
import AddorderProucttable from './Components/AddorderProucttable' //添加商品订单
import { queryPoolAmount, FindDetailsById, checkPrice } from '@/api/api'
import { Storage } from '@/utils/storage'
import { Loading } from 'element-ui'
import cals from './js/cals.js'
export default {
  name: 'shopsettle',
  data() {
    return {
      calSucessMsg: '',
      calSucessFlag: false,
      remarks: '', //文本值
      num: 1, //暂时需要
      orderBoolean: false,
      titles: '', //点击弹框，显示操作类型名称 暂存 和 提交订单
      visible: false,
      height: 0,
      tableData: null,
      id: '',
      orderCode: '',
      productModal: {},
      orderInfo: {
        amount: 0,
        promotionAmount: 0,
        repAmount: 0,
        usableAmount: 0,
        maxDiscountAmount: 0,
        actualAmount: 0,
        discountAmount: '',
        weightOfKilogram: 0,
      },
      receivingInfo: {},
      startShipQuantity: 0, //起运量
      tableScrollTop: 0,
      loadingInstance: null,
      submitLoading: false,
      isCloseHint: true,
    }
  },
  components: {
    ReceivingInf, //收货信息
    OrderInfo, //订单信息
    // ReplenOrderInfo, //促销政策
    SubmitholdOrder, //暂存订单，订单结算，取消
    AddprouctShop, //添加货补商品按钮
    AddorderProucttable,
  },
  created() {
    let { id } = { ...this.$route.query }
    this.id = id
  },
  mounted() {
    this.tableScrollTop = this.$refs.orderRef.offsetTop
    this.queryPoolAmount()
    if (this.id) {
      this.findDetailsById(this.id)
    }
    // if (window.history && window.history.pushState) {
    //   // 向历史记录中插入了当前页
    //   history.pushState(null, null, document.URL)
    //   window.addEventListener('popstate', this.goBack, false)
    // }
    //初始化关闭
    // window.addEventListener('beforeunload', (e)=>this.browerStatus(e))
    this.$nextTick(() => {
      window.onbeforeunload = (e) => {
        e = e || window.event
        // 兼容IE8和Firefox 4之前的版本
        if (e) {
          e.returnValue = '关闭提示'
        }
        // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
        return '关闭提示'
      }
    })
  },
  destroyed() {
    // window.removeEventListener('popstate', this.goBack, false)
    window.onbeforeunload = null
    // window.removeEventListener('beforeunload', (e)=>this.browerStatus(e))
  },
  methods: {
    //返回事件
    goBack() {
      this.$confirm('退出后将无法保存订单信息', '是否退出订单结算界面', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          window.history.back()
        })
        .catch(() => {
          if (window.history && window.history.pushState) {
            // 向历史记录中插入了当前页
            history.pushState(null, null, document.URL)
            window.addEventListener('popstate', this.goBack, false)
          }
        })
    },
    changeCal(val) {
      this.calSucessMsg = val.calSucessMsg
      this.calSucessFlag = val.calSucessFlag
    },
    findDetailsById(id) {
      this.loadingInstance = Loading.service()
      FindDetailsById(id).then((res) => {
        this.loadingInstance.close()
        this.remarks = res.result.remarks
        this.receivingInfo = {
          companyName: res.result.companyName || '矿泉水集团',
          temporaryFlag: res.result.temporaryFlag,
          orderType: res.result.type || '1',
          customerCode: res.result.cusCode,
          customerName: res.result.cusName,
          giveDate: res.result.giveDate,
          contactName: res.result.contactsName,
          contactPhone: res.result.contactsPhone,
          pickType: res.result.pickType,
          pickAdress: res.result.pickAdress,
          ext1: res.result.ext1, //订单供货方式
          ext2: res.result.ext2, //订单运输方式
          ext4: res.result.ext4, //提货人姓名
          ext5: res.result.ext5, //身份证号
          ext6: res.result.ext6, //车牌号
          ext10: res.result.ext10,
          ext40: res.result.ext40,
          ext37: res.result.ext37,
          ext38: res.result.ext38,
          ext39: res.result.ext39,
          startShipQuantity: 0, //起运量
          remarks: res.result.remarks,
          destinationCode: res.result.destinationCode || res.result.pickAdress,
          usableAmount:
            res.result.usableAmount < 0 ? 0 : res.result.usableAmount,
        }
        if (res.result.ext3) {
          this.receivingInfo.ext3 = res.result.ext3 //发票类型
        }
        this.orderInfo = {
          amount: res.result.amount < 0 ? 0 : res.result.amount,
          promotionAmount:
            res.result.promotionAmount < 0 ? 0 : res.result.promotionAmount,
          repAmount: res.result.repAmount < 0 ? 0 : res.result.repAmount,
          usableAmount:
            res.result.usableAmount < 0 ? 0 : res.result.usableAmount,
          maxDiscountAmount: res.result.maxDiscountAmount,
          actualAmount:
            res.result.actualAmount < 0 ? 0 : res.result.actualAmount,
          discountAmount:
            res.result.discountAmount <= 0 ? '' : res.result.discountAmount,
          weightOfKilogram:
            res.result.weightOfKilogram < 0 ? 0 : res.result.weightOfKilogram,
        }
        this.tableData = res.result.groupItemVos
        this.orderCode = res.result.orderCode
      })
    },
    queryPoolAmount() {
      const params = {
        customerCode: Storage.l.get('customerCode'),
      }
      queryPoolAmount(params).then((res) => {
        if (res.success) {
          this.orderInfo = {
            ...this.orderInfo,
            usableAmount:
              res.result.discountUsableAmount < 0
                ? 0
                : res.result.discountUsableAmount,
          }
        }
      })
    },
    // 提交订单，暂存，取消 组件
    SubmitholdOrders(bool) {
      this.orderBoolean = bool
    },
    /**
     * @description: 提交订单N  暂存订单Y  取消Z
     * @param {*}
     * @return {*}
     * @author: txp
     */
    submitOrderList(type) {
      if (this.calSucessFlag === 'N') {
        this.$message.error('该订单有存在行项目不满足的情况，请检查订单行信息')
        return false
      }
      if (type === 'N') {
        this.titles = type
        this.receivingInfo.temporaryFlag = 'N'
      } else if (type === 'Y') {
        this.titles = type
        this.receivingInfo.temporaryFlag = 'Y'
      } else {
        this.$router.go(-1)
        return false
      }

      this.receivingInfo = {
        ...this.$refs.info.info,
        remarks: this.remarks,
        weightOfKilogram: this.orderInfo.weightOfKilogram,
        maxDiscountAmount: this.orderInfo.maxDiscountAmountl,
        temporaryFlag: type,
      }
      if (
        this.receivingInfo.ext1 === 'shipping_method_straight_spell' &&
        !this.remarks
      ) {
        this.$message.error(
          '若供货方式选择工厂直发拼单，则备注必填，请填写拼单的订单号、拼单客户名称等信息'
        )
        return false
      }
      if (
        this.receivingInfo.ext1 === 'shipping_method_transit_share' &&
        !this.remarks
      ) {
        this.$message.error('中转仓发货拼单，备注必填')
        return false
      }
      // console.log(this.receivingInfo)
      // console.log(this.receivingInfo.pickType)
      // return false
      if (this.receivingInfo.pickType != '1') {
        if (
          this.receivingInfo.destinationCode &&
          this.receivingInfo.contactName &&
          this.receivingInfo.contactPhone &&
          this.receivingInfo.giveDate &&
          this.receivingInfo.pickAdress &&
          this.receivingInfo.ext1 &&
          this.receivingInfo.ext3 &&
          this.receivingInfo.ext2
        ) {
          this.checkPriceFun()
        } else {
          this.$message.error('收货信息请填写完整')
        }
      } else {
        if (
          this.receivingInfo.destinationCode &&
          this.receivingInfo.contactName &&
          this.receivingInfo.contactPhone &&
          this.receivingInfo.giveDate &&
          this.receivingInfo.pickAdress &&
          this.receivingInfo.ext1 &&
          this.receivingInfo.ext3 &&
          this.receivingInfo.ext4 &&
          this.receivingInfo.ext5 &&
          this.receivingInfo.ext6
        ) {
          this.checkPriceFun()
        } else {
          this.$message.error('收货信息请填写完整')
        }
      }
    },
    // 暂用===========添加商品
    resetPopupData() {
      this.visible = false
    },
    submitPopupData(val) {
      this.productModal = {
        product: val,
        modelType: this.modelType,
      }
      this.visible = false
    },
    // 关闭弹框（头部的X）
    handleClose() {
      this.visible = false
    },
    addshopcarspruct(modelType) {
      this.modelType = modelType
      this.visible = true
    },
    quantityOrder(val) {
      this.orderInfo = {
        ...this.orderInfo,
        ...val,
      }
    },
    /**
     * 最低价校验
     */
    async checkPriceFun() {
      this.orderBoolean = true
      // const groupItemVos = cals.handleSubmitCal('submit')
      // const params = {
      //   ...this.receivingInfo,
      //   contactsName: this.receivingInfo.contactName,
      //   contactsPhone: this.receivingInfo.contactPhone,
      //   pickAdress: this.receivingInfo.pickAdress,
      //   temporaryFlag: this.receivingInfo.temporaryFlag || 'N',
      //   discountAmount: this.discountAmount,
      //   cusCode: this.receivingInfo.customerCode,
      //   cusName: this.receivingInfo.customerName,
      //   fromType: 0,
      //   id: this.id,
      //   type: this.receivingInfo.orderType,
      //   orderCode: this.orderCode,
      //   groupItemVos
      // }
      // this.submitLoading = true
      // try {
      //   const res = await checkPrice(params)
      //   this.submitLoading = false
      //   if (res.success) {
      //     this.orderBoolean = true
      //   } else {
      //     this.$message.error(res.message)
      //   }
      // } catch {
      //   this.submitLoading = false
      // }
    },
    /**
     * 获取起订量
     */
    getStartShipQuantity(val) {
      this.receivingInfo.startShipQuantity = val
      this.startShipQuantity = val
      // console.log(this.receivingInfo)
      // this.receivingInfo = JSON.parse(JSON.stringify(this.receivingInfo))
      // this.$set(this.receivingInfo,'startShipQuantity',val)
    },
  },
}
</script>
<style lang="scss" scoped>
.max-font {
  font-size: 16px;
  font-weight: bold;
  padding-left: 4px;
}
.color-red {
  color: red;
}
.shopsettle {
  .shopsettle_orderinfo {
    position: relative;
    .addsprouct {
      position: absolute;
      top: 4px;
      right: 0px;
    }
  }
  .submit {
    margin: 30px 0px;
    /deep/ .el-button {
      width: 168px;
    }
  }
  /deep/.el-table {
    td {
      vertical-align: top; //让表格内容不垂直居中
    }
  }
  // 设置输入框的背景颜色
  /deep/.el-textarea__inner {
    background-color: #fafafa;
  }
  .userInfo {
    border: 1px solid #d8d8d8;
    border-radius: 4px;
    .flex-info {
      align-items: center;
      justify-content: start;
    }
    div {
      p {
        // width: 25%;
        min-width: 18%;
        margin-right: 20px;
        // font-size: 12px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
/deep/.content-scrollbar {
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  height: 100%;
  // max-height: 400px;
}
.warning-row {
  // background: rgba(255, 0, 0, 0.3) !important;
  color: red;
  text-align: right;
  margin-top: 20px;
}
</style>
